import { InsurerFormValues } from '@/core/domain/people/Insurers/Insurers.types';
import { removeCpfCnpjMask } from '@/utils/mask/removeMask';

type Callback = (values: InsurerFormValues) => Promise<unknown>;

export default async function handlerGeneralUpdate(
  values: InsurerFormValues,
  active: boolean,
  callback: Callback,
) {
  const obj: InsurerFormValues = {
    ...values,
    cnpj: removeCpfCnpjMask(values.cnpj),
    active,
  };

  await callback(obj);
}
